import { isStreamIQ } from '@/shared/lib'

export async function getVodRecommendationStreamIQSlider() {
    if (isStreamIQ()) {
        try {
            const module =
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                await require('@/clients/streamiq/features/VODStreamIQ/components/VodRecommendationsSlider')

            return module.default
        } catch (error) {
            console.warn(
                'VodRecommendationsSlider module is missing. StreamIQ-specific features are disabled.',
                error
            )
            return null
        }
    }
}
